import { render, staticRenderFns } from "./StorageLossRightPanel.vue?vue&type=template&id=0486fbf3"
import script from "./StorageLossRightPanel.vue?vue&type=script&lang=js"
export * from "./StorageLossRightPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports